export default __webpack_public_path__ + "static/media/2501252.3026767e.png";